// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lubbock-texas-offer-jan-2021 em{font-size:14px;margin-top:44px;display:block}.pi-day-challenge{background-image:none;background:#8a0ffe}.brownsville .toggle{top:50px;transition:all .3s ease}@media(min-width:640px){.brownsville .toggle{top:65px}}@media(min-width:1170px){.brownsville .toggle{top:117px}}", ""]);
// Exports
module.exports = exports;
